<div class="invitiation-filter">
  <h5 class="filter-title">{{titleTranslateKey | translate}}</h5>
  <mat-form-field>
    <mat-label>{{label}}</mat-label>
    <mat-select #selector
                (selectionChange)="selectionChanged($event.value)"
                multiple
                [formControl]="selectedEntries">
      <mat-select-trigger *ngIf="selectedEntries.value?.length">
        {{'INTEGRATIONS.FILTER_VALUES.' + displayLabel | translate }}
        <div *ngIf="selectedEntries.value?.length > 1" class="more-items-label">
          (+{{selectedEntries.value.length - 1}})
        </div>
      </mat-select-trigger>
      <mat-checkbox
        class="phone-numbers-filter-option select-all"
        [(ngModel)]="allSelected"
        [(indeterminate)]="indeterminate"
        (change)="toggleAllSelect()">
        {{'SELECT_ALL' | translate }}
      </mat-checkbox>
      <mat-option *ngFor="let entry of entries"
                  [value]="entry.key"
                  class="invitiation-filter-option"
      >
        {{entry.translateKey | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
